import { useNavigate } from "react-router-dom"
import styles from "./CreateStorePageCard.module.scss"

const CreateStorePageCard = ({ src, title, price }) => {

  const navigate = useNavigate()

  const isFree = price.toLowerCase() === "free"

  return (
    <div className={styles.card}>
      <div className="position-relative">
        <img src={src} alt={title} className={styles.previewImage} />
        <button className={styles.previewBtn} onClick={() => navigate('/settings/store-theme-preview')}>
          Preview
        </button>
      </div>
      <div className="d-flex align-items-center justify-content-between">
        <div className="fw-medium">{title}</div>
        <div className={`${styles.price} ${isFree ? styles.free : styles.paid}`}>{price}</div>
      </div>
    </div>
  )
}

export default CreateStorePageCard
